<template>
  <div class="fixed inset-0 flex items-center justify-center z-50">
    <div class="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
    <div
      class="bg-gray-800 text-white rounded-lg shadow-xl border border-gray-700 p-5 max-w-md z-10 w-full mx-4 md:w-auto"
    >
      <div class="flex justify-between items-start mb-4">
        <h3 class="text-lg font-medium text-red-400">Blokiraj korisnika</h3>
        <button
          @click="$emit('close')"
          class="text-gray-400 hover:text-gray-300 transition-colors"
        >
          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
      </div>

      <div class="bg-red-900 bg-opacity-20 p-3 rounded-lg mb-4">
        <p class="text-base text-gray-100">
          Da li ste sigurni da želite da blokirate korisnika
          <span class="font-semibold text-white">{{ otherUser?.username }}</span
          >?
        </p>
      </div>

      <p class="text-sm text-gray-300 mb-4">
        Nakon blokiranja, nećete više moći da komunicirate sa ovim korisnikom.
        Ova akcija je trajna i može se poništiti samo kontaktiranjem
        administratora sajta putem email-a.
      </p>

      <div class="flex justify-end space-x-3">
        <button
          @click="$emit('close')"
          class="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-500 transition-colors"
        >
          Odustani
        </button>
        <button
          @click="$emit('confirm')"
          class="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
        >
          Blokiraj
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'BlockModal',
  props: {
    otherUser: {
      type: Object as PropType<any>,
      default: null,
    },
  },
  emits: ['close', 'confirm'],
});
</script>
